export const urlRegex = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const currencyRegex = /^[\d]*\.?(\d{1,2})?$/
export const wholeNumbersRegex = /(^$|^[0-9]\d*$)/
export const noSpecialCharacterRegex = /^[A-Za-z0-9 ]+$/
export const currencyRegexTypeText = /(^$|^([0-9,]+(\.\d{0,2})?|\.?\d{1,2}?)$)/
export const intlMobileNumber = /^(?!00\d)\d+/
export const leadingOnlyOneZero = /^(?!00)/
